import Currencies from '../dynamics/currencies'

export const getCurrencyById = (currencyId) => Currencies.find(({ id }) => id === currencyId)